define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query",
	"Specification",
	"./IncrementSizesMixin"
], function(declare,lang,Action,ViewRef,Ref,xml,Query,Specification,IncrementSizesMixin) {

	return declare([Ref, IncrementSizesMixin], {
		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return Action including ViewRef and optionally Filter and FilterView to select defaults
			// if Increment has 2-d SizeRange, only 2-d sizerange of same Dimension1Type and Dimension1Type can be selected
			return lang.mixin(new Action(), {
				urlContext: this._getUrlContext(ctx),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_url: Specification.URL_ADMIN,
					m_id: "AggregateSizeChartSizeRange"
				}),
				m_fixedQuery: this._getSizeRangeQuery(ctx)
			});
		},

		_getSizeRangeQuery: function(/*Context*/ctx) {
			// if Increment has 2-d SizeRange, only 2-d SizeRange of same Dimension1Type and Dimension1Type can be selected
			if (this._hasTwoDimSizeRange(ctx)) {
				var increment = this._getIncrement(ctx);

				return new Query()
						.Attr("Dimension1Type", xml.OP_EQUALS, increment.Dimension1Type)
						.Attr("Dimension2Type", xml.OP_EQUALS, increment.Dimension2Type);
			}

			return null;
		},

		_getUrlContext: function(/*Context*/ctx) {
			// summary: construct the urlContext for Increment aggregate SizeRange action
			// Since the variables on the query are the Increment’s Dimension1Type and Dimension2Type, we use them as the urlContext.
			// It will work for 1-d increment too since the dimension1/2 types are all the same across all 1-d increment.
			var increment = this._getIncrement(ctx);
			return increment.Dimension1Type + " " + increment.Dimension2Type;
		}
	});
});